module.exports = __webpack_public_path__ + "fonts/Inter-SemiBold.01fdc382.woff2";